// Our product database.
const sampleProducts = [
  {
    id: 1588439299462,
    name: "Tetrion All Purpose Filler 1.5 Kg",
    groupCategory: "DIY Supplies",
    category: "Fillers",
    price: 8.99,
    description:
      "TA well known, all purpose filler for interior and exterior use, creating a tough, water resistant, smooth finish. Also resistant to cracking and shrinking. Can be drilled and tapped. Can be used on most household materials such as: plaster, wood, stone, concrete, glass, metal and brick.",
    popular: true,
    imageUrls: [
      "https://x/images?q=tbn%3AANd9GcTkRZz8cOqwo1o6YqGpNM8ydyTW0jpAp-vzpxiaxoCge1hKzeMw-V_C3isoS-yvsHFBzJ4YQTWj&usqp=CAc",
      "https://xencrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRKvO6hf1X_A9sMW5bCzd9JmzlBC7mwAFn7qy34cWYFgNfPAm43OpgdfiYY7g&usqp=CAc"
    ]
  },
  {
    id: 2,
    name: "Border/Overlap Adhesive 500 g",
    groupCategory: "DIY Supplies",
    category: "Adhesives",
    price: 4.99,
    description:
      "Bartoline Border & Overlap Adhesive is a specially formulated adhesive for fixing decorative borders to interior surfaces, including vinyl. Possessing high grab properties, easy to apply to all borders, and can also be used to reattach torn and ripped wallcoverings, and fixing seams. Application: Used primarily for fixing decorative borders to interior surfaces, and for minor repairs to existing wallcoverings. Simple to apply and enables the border to slide into position easily. Coverage: Approximately 250g of adhesive for a standard 10m x 13cm border.",
    popular: false,
    imageUrls: [
      "https://i.ebayimg.com/images/g/YXYAAOSwVb5eQ5bR/s-l640.jpg",
      "http://www.allbees.co.uk/images/thumbnails/280/280/product/1/11145.jpg"
    ]
  },
  {
    id: 3,
    name: "All Weather Trowel Bitumen Mastic 1 Litre",
    groupCategory: "Building Supplies",
    category: "Damp Proofing",
    price: 4.98,
    description:
      "Everbuilds 903 Black Jacks bitumen trowel mastic is a heavily filled bituminous compound that is black when applied. It has added fibres for added reinforcement. This is a semi flexible product and is suitable for sealing and filling holes in mastic asphalt, roofing felt, corrugated iron, metal gutting and downpipes.",
    popular: true,
    imageUrls: [
      "http://www.allbees.co.uk/images/detailed/1/22027.jpg",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRhs9O-ccJ1Mfk4JKCKXomwb7ZY2kdRCnOyDwT37OLvfTVMb6Wc0N8E0QAEpXCRxLcQL6j0LMw&usqp=CAc"
    ]
  },
  {
    id: 4,
    name: "Brick and Patio Cleaner 2 Litre",
    groupCategory: "Building Supplies",
    category: "Patio Cleaner",
    price: 13.80,
    description:
      "Sika Brick & Patio Cleaner is a general purpose, acid based cleaning solution for use on brickwork, concrete and paving. Typical uses include cleaning brickwork, concrete paths, drives and paved patios. Ideal for removing stains and degreasing brickwork and concrete. Sika Brick & Patio Cleaner should be diluted 1 part to 2 parts water, however, if the desired effect is not achieved then the amount of water added can be reduced. The cleaner is brush applied using a circular scrubbing action before washing off any remaining Sika Brick & Patio Cleaner or residue with clean water. Consumption will depend upon the porosity or contamination of the surface to be treated, typically this will be 4m2 per litre.",
    popular: false,
    imageUrls: [
      "http://www.allbees.co.uk/images/thumbnails/280/280/product/12/2bd18x-qmCMoY9ofFHnfEa2qF4BZQeJ9fCBHfYWt-g0.png",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRk01TJOFqF-6upaV5BeENn2VGrPxxjJjZi9lmvDnklwKXmXL9_EQqvVevKFSYE-MS79ovfqjI&usqp=CAc"
    ]
  },
  {
    id: 5,
    name: "Hampstead Lever Door Handle ",
    groupCategory: "Ironmongery",
    category: "Fillers",
    price: 28.18,
    description:
      "Constructon: A stainless steel handle mounted on a 10mm thick stainless steel rose with integral spring and independent stop washer. The unique Karcher Design 3 part rose system ensures the lever handles are fixed in the most robust and secure method. The solid mounting plates are first secured to the door with bolt through fixings and then the lever handles are attached to them with a screw on rose. A grub screw retained spindle offers the final point of secure fixing. This method has been proven to withstand continued and enduring use in commercial and public buildings. Note: Please ensure all latches and/or lockcases can accept bolt thru' fixings. For compatible latches and lockcases, please see our accessories page or buy complete sets below. We supply latches and lock cases in stain stainless steel finish only with all our stainless steel levers.",
    popular: true,
    imageUrls: [
      "http://www.allbees.co.uk/images/thumbnails/280/96/product/12/30055_73cu-4c.png",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTEjSig6jw9vmeaugX-QcIAg5wh7_kiSuYkoBdNQqcMm551Y0TCTsfgcLZ5XNIDBZB1Y59lRyg&usqp=CAc"
    ]
  },

  {
    id: 7,
    name: "Soss Hinge Satin 203 45 x 13 mm Single",
    groupCategory: "Ironmongery",
    category: "Fillers",
    price: 10.37,
    description: "203 Genuine Soss Hinge Satin 45 X13mm Single. Elegant. concealed hinges. Invisible when the door is closed. Super Strong and durable",
    popular: false,
    imageUrls: [
      "http://www.allbees.co.uk/images/detailed/3/34022.jpg",
      "https://www.locksonline.com/image/cache/catalog/product-images/01067279_0-228x228.jpg"
    ]
  },
  {
    id: 8,
    name: "Bookcase Raised Channel Strip 1.8m",
    groupCategory: "Shelving and Tools",
    category: "Fillers",
    price: 4.92,
    description: "Raised Bookcase Strip - 1829 x 24mm - Bright Zinc PlatedManufactured from strong rolled steelDesigned for surface fitting - shelves must be a minimum of 7mm shorter than the internal width of the cabinetThe wide flange means that these bookcase strips can be welded to the surface for a heavier duty, permanent fitUse heavy duty raised bookcase clips for large or heavier shelvesThickness: 1mmSlot centres: 12.7mmSection depth: 3.4mmFixing centres: 152.4mmFasteners required: 12 x No.4NOTE: Raised bookcase clips must be used for this system - flat versions WILL NOT work",
    popular: true,
    imageUrls: [
      "http://www.allbees.co.uk/images/thumbnails/280/280/product/3/40002.jpg",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcS-vm1ab8Y__ePOxtGxRsgku-TWZXOiUH-MKTDp9oMhpgbsY811oClgAoMpFLK-sWgr2b_gZLNI&usqp=CAc"
    ]
  },
  {
    id: 9,
    name: "Handrail Bracket 75 mm Polished Chrome",
    groupCategory: "Shelving and Tools",
    category: "Fillers",
    price: 3.73,
    description: "75 mm Polished Chrome Handrail Bracket. Heavyweight handrail bracket.",
    popular: false,
    imageUrls: [
      "http://www.allbees.co.uk/images/detailed/3/41115.jpg",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQBEYCJ4bV1CzbHgZmqyrA1ZpWcXxiJj6gQ0vzDSVDI4lLc0b96mCJd7PmiVJnIvOLJPpwvWHg&usqp=CAc"
    ]
  },
  {
    id: 10,
    name: "Nitromors Paint and Varnish Remover 2 Litre",
    groupCategory: "DIY Supplies",
    category: "Painting",
    price: 27.38,
    description: "Nitromors fast acting, all-purpose remover is excellent at stripping layers of paint, varnish and lacquer. The green coloured gel is easy to see and apply, gives superior coverage and is slow to evaporate. The new double strength formula strips up to twice the paint layers. Ideal for wood, metal and masonry. It is non-drip, making it ideal for vertical surfaces.",
    popular: true,
    imageUrls: [
      "http://www.allbees.co.uk/images/detailed/1/12506.jpg",
      "data:image/jpeg;base64,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"
    ]
  },
  {
    id: 11,
    name: "Prosolve Floor Paint 5 Litre",
    groupCategory: "DIY Supplies",
    category: "Painting",
    price: 34.39,
    description:
      "Prosolve Industrial Floor Paint is a single pack quick dry floor paint which is hard wearing and durable against abrasion / impact and exposure solvent, salt and water. Easy to apply with brush or roller and available in a choice of finishes. Suitable for heavy duty commercial and industrial areas",
    popular: false,
    imageUrls: [
      "http://www.allbees.co.uk/images/thumbnails/280/398/detailed/11/21257.png",
      "https://media.toolstoday.co.uk/media/catalog/product/cache/1/small_image/210x/9df78eab33525d08d6e5fb8d27136e95/f/l/floor_paint.jpg"
    ]
  },
  {
    id: 12,
    name: "Sealocrete PVA Seal and Adhesive 5 Litre",
    groupCategory: "DIY Supplies",
    category: "Painting",
    price: 9.95,
    description:
      "General purpose adhesive and sealer. For construction and general purpose bonding of wood components." +
      "• Gluing of particle board, MDF, Formica and veneers." +
      "• Colour: white, dries translucent." ,
    popular: true,
    imageUrls: [
      "http://www.allbees.co.uk/images/thumbnails/280/280/product/1/22014.jpg",
      "https://www.arco.co.uk/103/content/product/4481932.JPG"
    ]
  }
];

// List of item categories.
const categories = [
  {
    name: "All Building Supplies",
    url: "/?category=Building Supplies",
  },
  {
    name: "Bags and Buckets",
  },
  {
    name: "Beadings",
  },
  {
    name: "Construction Hardware",
  },
  {
    name: "Cutting and Grinding",
  },
  {
    name: "Patio Cleaner",
  }
];

const categories2 = [
  {
    name: "All DIY Supplies",
    url: "/?category=DIY Supplies",
  },
  {
    name: "Adhesives",
  },
  {
    name: "Fillers",
  },
  {
    name: "Painting",
  },
  {
    name: "Sealants",
  }
];

// Data for rendering menu.
const dataForTheMenu = [
  { name: "Home", url: "/", icon: "home", id: 0, type: "link"},
  { name: "All Categories", url: "/?category=All Categories", icon: "list", id: 1, type: "topCategory"},
  {
    name: "Building Supplies",
    id: 20,
    icon: "storeMailDirectory",
    type: "groupCategory",
    children: categories.map((x, i) => {
      return {
        name: x.name,
        id: 20 + i,
        url: x.url == null ? "/?category=" + x.name : x.url,
      };
    })
  },
  {
    name:"DIY Supplies",
    id: 30,
    icon: "build",
    type: "groupCategory",
    children: categories2.map((x, i) => {
      return {
        name: x.name,
        id: 3 + i,
        url: x.url == null ? "/?category=" + x.name : x.url,
      };
    })
  },

];


export { sampleProducts, categories, dataForTheMenu };
